import script from "./FilterMappings.vue?vue&type=script&setup=true&lang=js"
export * from "./FilterMappings.vue?vue&type=script&setup=true&lang=js"

import "./FilterMappings.vue?vue&type=style&index=0&id=1a4be5fb&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\ProtectionGuruVue\\client-app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a4be5fb"]])

export default __exports__